import { getQueryParameterByName } from './queryParameters';

const dtSourceProviderKey = 'dt';
export const sessionSourceProviderIdKey = 'sessionSourceProviderId';

export const dataSources = {
    queryParam: 1,
    session: 2
};
export const getSourceProviderId = (dataSource) => {

    let sourceProviderId;
    const dtSourceProviderValue = getQueryParameterByName(dtSourceProviderKey);
    const sourceProviderValue = getQueryParameterByName('sourceProviderId');

    if (dataSource === dataSources.queryParam) {
        if(sourceProviderValue) {
            sourceProviderId = sourceProviderValue;
        }else if (dtSourceProviderValue && dtSourceProviderValue === '1') {
            sourceProviderId = dtSourceProviderKey;
        }
    }else if (dataSource === dataSources.session) {
        sourceProviderId = sessionStorage.getItem(sessionSourceProviderIdKey);
    }

    return sourceProviderId;
};

